<!-- 图片预览组件 -->
<template>
        <el-image-viewer 
            v-if="visible" 
            :url-list="urls" 
            :initial-index="index"
            teleported
            @close="close"
            >
        </el-image-viewer>
</template>

<script setup>
defineOptions({
    name: 'PreviewImage'
})
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
defineProps({
    urls: {
        type: Array,
        default: () => []
    },
    index: {
        type: Number,
        default: 0
    },
    visible:{
        type: Boolean,
        default: false
    }
})
const emit = defineEmits(['update:visible'])
const state = reactive({
})
const close = ()=>{
    emit('update:visible', false)
}
onMounted(() => {
})
</script>
<style lang='scss' scoped></style>